var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{directives:[{name:"disabled-icon-focus",rawName:"v-disabled-icon-focus"}],attrs:{"label":_vm.label,"items":_vm.listOfCountries,"item-text":"name","item-value":"code","clearable":"","dense":"","outlined":"","rules":_vm.rules},model:{value:(_vm.countryData),callback:function ($$v) {_vm.countryData=$$v},expression:"countryData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }